class FakeClick {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.dataset.fakeClick)
    }

    onInit () {
        this._elem.addEventListener('click', e => this._fakeClick(e))
    }

    _fakeClick (e) {
        e.preventDefault()
        document.querySelector(this._data.elem).click()
        if (this._data.refresh && !this._data.delay) window.location.reload()
        setTimeout(e => {
            window.location.reload()
        }, this._data.delay)
    }
}

export default FakeClick



// WEBPACK FOOTER //
// ./src/scripts/components/FakeClick.js